const fetchAPI = async (url: string) => {
	const response = await fetch(url, {
		headers: {
			'X-WP-Nonce': window.sageverseData.nonce || '',
		},
	});
	const json = await response.json();

	return json;
};

export default fetchAPI;
